import React, { Component } from 'react';
const CDN_URL = process.env.REACT_APP_CDN_URL;

const invoicePaidDefault = `${CDN_URL}support/ticketing/invoice-paid-default-lg.png`;
const invoicePaidSelected = `${CDN_URL}support/ticketing/invoice-paid-selected-lg.png`;
const invoicePastDueDefault = `${CDN_URL}support/ticketing/invoice-pastdue-default-lg.png`;
const invoicePastDueSelected = `${CDN_URL}support/ticketing/invoice-pastdue-selected-lg.png`;
const invoiceDueDefault = `${CDN_URL}support/ticketing/invoice-due-default-lg.png`;
const invoiceDueSelected = `${CDN_URL}support/ticketing/invoice-due-selected-lg.png`;
export default class IconInputComponent extends Component {
	getCustomIcon = (status, selected, state) => {
		if (selected === 'selected' || state === 'hovered') {
			switch (status) {
				case 'Paid':
					return invoicePaidSelected;
				case 'PastDue':
					return invoicePastDueSelected;
				case 'Due':
					return invoiceDueSelected;
				default:
					return invoiceDueSelected;
			}
		} else {
			switch (status) {
				case 'Paid':
					return invoicePaidDefault;
				case 'PastDue':
					return invoicePastDueDefault;
				case 'Due':
					return invoiceDueDefault;
				default:
					return invoiceDueDefault;
			}
		}
	};
	onMouseEnter = (id, selected, status) => {
		const icon = document.getElementById(`image-${id}`);
		if (icon) {
			icon.src = this.getCustomIcon(status, selected, 'hovered');
		}
	};
	onMouseLeave = (id, selected) => {
		const icon = document.getElementById(`image-${id}`);
		if (icon) {
			icon.src = this.getCustomIcon(status, selected);
		}
	};
	render() {
		const {
			icon,
			classes,
			children,
			showErrorMessage,
			customOnClick,
			data,
			id,
			selected,
			customIcons,
			cypressId,
		} = this.props;

		return (
			<div
				className={`icon-input-component ${selected} ${classes} `}
				onClick={customOnClick ? () => customOnClick(data, id) : () => {}}
				data-cy={cypressId}
				onMouseEnter={
					customIcons
						? () => {
								this.onMouseEnter(id, selected, data.status);
						  }
						: () => {}
				}
				onMouseLeave={
					customIcons
						? () => {
								this.onMouseLeave(id, selected, data.status);
						  }
						: () => {}
				}
				id={id}
			>
				<div className='icon-section'>
					{icon && (
						<img
							id={`image-${id}`}
							src={customIcons ? this.getCustomIcon(data.status, selected) : icon}
							alt='icon'
						/>
					)}
				</div>
				<div className='details-section'>
					{children}
					{showErrorMessage && (
						<div className='match-error-message body-copy'>
							Passwords did not match....try again!
						</div>
					)}
				</div>
			</div>
		);
	}
}
